export const getOrCreateDataLayer = () => (window.dataLayer = window.dataLayer || []);
//# sourceMappingURL=dataLayer.js.map